// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CharacterCountController from "./character_count_controller"
application.register("character-count", CharacterCountController)

import CommentsToggleController from "./comments_toggle_controller"
application.register("comments-toggle", CommentsToggleController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import MapController from "./map_controller"
application.register("map", MapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import PlanSelectorController from "./plan_selector_controller"
application.register("plan-selector", PlanSelectorController)

import PreviousMessagesController from "./previous_messages_controller"
application.register("previous-messages", PreviousMessagesController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import ScrollToBottomController from "./scroll_to_bottom_controller"
application.register("scroll-to-bottom", ScrollToBottomController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)
